import {
  CONTEXT_KEY,
  DefaultAtoms,
  DefaultEntities,
  type IPrivateUserData,
  type ITransaction,
} from "@atoms/atom-types";

/** Same role keys as backend `getRolesFromContext` (for UI helpers). */
export function getProvisionRoleKeysFromUser(user: IPrivateUserData): string[] {
  if (!user) {
    return [];
  }
  if (user.isAdmin) {
    return ["admin"];
  }
  return Array.from(new Set(["user", ...(user.permissions ?? [])]));
}

/** Same logic as backend `backend.provision.getRolesFromContext`. */
export async function getProvisionRolesFromTransaction(
  transaction: ITransaction,
): Promise<string[]> {
  const userId = transaction.getActingUserOrThrow();
  const user = await transaction.aquireAtomValue<IPrivateUserData>(
    DefaultAtoms.PersonalUserData,
    {
      [CONTEXT_KEY(DefaultEntities.User)]: userId,
    },
  );
  return getProvisionRoleKeysFromUser(user);
}
